import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, ClipPath, G, Defs, Rect } from "react-native-svg";

import appStyles from "../../../../appStyles";

export default function HistoryIcon(props) {
  const w = props.width || 40;
  const h = props.height || 40;

  return (
    <TouchableOpacity style={[appStyles.iconContainer, props.style]} {...props}>
      <Svg
        width={w}
        height={h}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_history)">
          <Path
            d="M20 12C17.879 12.0023 15.8455 12.8459 14.3457 14.3457C12.8459 15.8455 12.0023 17.879 12 20C12 20.1768 12.0702 20.3464 12.1953 20.4714C12.3203 20.5964 12.4899 20.6667 12.6667 20.6667C12.8435 20.6667 13.013 20.5964 13.1381 20.4714C13.2631 20.3464 13.3333 20.1768 13.3333 20C13.3299 18.5071 13.8266 17.056 14.744 15.8783C15.6615 14.7006 16.947 13.864 18.3954 13.5021C19.8437 13.1402 21.3716 13.2737 22.7352 13.8814C24.0989 14.4891 25.2197 15.5359 25.919 16.8549C26.6183 18.174 26.8557 19.6892 26.5934 21.1589C26.331 22.6285 25.5841 23.9681 24.4717 24.9637C23.3593 25.9594 21.9455 26.5538 20.4558 26.6522C18.9661 26.7506 17.4864 26.3473 16.2527 25.5067L17.456 24C17.4935 23.9528 17.5174 23.8963 17.5253 23.8366C17.5333 23.7769 17.5248 23.7161 17.501 23.6608C17.4771 23.6054 17.4387 23.5576 17.3898 23.5224C17.3409 23.4871 17.2834 23.4658 17.2233 23.4607L12.7753 23.082C12.7207 23.0773 12.6657 23.0862 12.6153 23.1079C12.5649 23.1295 12.5207 23.1633 12.4864 23.2061C12.4522 23.249 12.4291 23.2996 12.4191 23.3536C12.4092 23.4075 12.4127 23.4631 12.4293 23.5153L13.7907 27.7667C13.809 27.824 13.8426 27.8753 13.8878 27.9151C13.933 27.9549 13.9881 27.9817 14.0473 27.9927C14.0673 27.9966 14.0876 27.9986 14.108 27.9987C14.1581 27.9986 14.2076 27.9873 14.2527 27.9655C14.2979 27.9436 14.3375 27.9119 14.3687 27.8727L15.4207 26.5527C16.4503 27.2738 17.6354 27.7422 18.8798 27.9198C20.1243 28.0974 21.393 27.9792 22.5833 27.5749C23.7735 27.1705 24.8517 26.4914 25.7305 25.5925C26.6093 24.6937 27.2638 23.6004 27.6412 22.4013C28.0185 21.2022 28.1079 19.9311 27.9022 18.691C27.6965 17.4509 27.2015 16.2767 26.4573 15.2636C25.7131 14.2506 24.7406 13.4271 23.6187 12.8601C22.4968 12.2931 21.257 11.9984 20 12Z"
            fill="white"
          />
          <Path
            d="M19.9997 14.6665C19.8229 14.6665 19.6533 14.7367 19.5283 14.8618C19.4032 14.9868 19.333 15.1564 19.333 15.3332V19.9998C19.333 20.1766 19.4032 20.3462 19.5283 20.4712C19.6533 20.5963 19.8229 20.6665 19.9997 20.6665H24.6663C24.8432 20.6665 25.0127 20.5963 25.1377 20.4712C25.2628 20.3462 25.333 20.1766 25.333 19.9998C25.333 19.823 25.2628 19.6535 25.1377 19.5284C25.0127 19.4034 24.8432 19.3332 24.6663 19.3332H20.6663V15.3332C20.6663 15.1564 20.5961 14.9868 20.4711 14.8618C20.3461 14.7367 20.1765 14.6665 19.9997 14.6665Z"
            fill="white"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_history">
            <Rect
              width="16"
              height="16"
              fill="white"
              transform="translate(12 12)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
